import { useState, useEffect } from "react";
import { Select } from "antd";
import { InvoiceBill } from "@/views/invoice/manage/InvoiceManageTypes";

interface PropsType {
  bill: InvoiceBill;
  options?: labelsType[];
  returnMsg: (msg: returnMsgType) => void;
}
type labelsType = {
  label: string;
  value: string;
  amount: string;
}
type returnMsgType = {
  code: string;
  invoiceNum: string;
}

function SelectInvoice(props: PropsType) {
  const { bill, options, returnMsg } = props;
  const [invoiceNum, setInvoiceNum] = useState<string[]>([]);
  const [invoiceNumUpdate, setInvoiceNumUpdate] = useState<string>("");

  const handleSelect = (data: labelsType) => {
    let array = invoiceNum;
    array.push(data.value);
    setInvoiceNum(array);
    setInvoiceNumUpdate(JSON.stringify(array));
    //console.log(JSON.stringify(array))
  };

  const handleDeselect = (data: labelsType) => {
    let array = invoiceNum;
    let findIndex = array.indexOf(data.value);
    if (findIndex != -1) {
      array.splice(findIndex, 1);
    }
    setInvoiceNum(array);
    setInvoiceNumUpdate(JSON.stringify(array));
  };

  const def = options?.filter(e => e.amount == bill.billAmount?.toString());

  useEffect(() => {
    returnMsg({ code: bill.code, invoiceNum: invoiceNum.join(",") });
  }, [invoiceNumUpdate])

  useEffect(() => {
    let array: string[] = [];
    if (def?.length != undefined && def?.length > 0) {
      array.push(def[0].value);
      setInvoiceNum(array);
      returnMsg({ code: bill.code, invoiceNum: array.join(",") });
    }
  }, [])

  return (
    <>
      <Select
        mode="multiple"
        labelInValue
        defaultValue={def}
        options={options}
        filterOption={(input, option) =>
          (option?.label ?? '').toString().indexOf(input) >= 0
        }
        onSelect={handleSelect}
        onDeselect={handleDeselect}
      >
      </Select >
    </>
  );
}

export default SelectInvoice;